import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../lang/en-us';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import { RootStateType } from '../../redux-store/reducers';
import { OTP_ACTIONS } from '../../utils/constants';
import {
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
    updateSecurityQuestionsForUser,
} from '../../redux-store/actions/nct';
import { EncodeBase64, maskMobileNumber } from '../../utils/utilityFunctions';

const { dashboard, updateSecurityQuestion } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function UpdateSecurityQuestionsOtp(props: any) {
    const { mobile = null, addBank = false } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        try {
            const { pan, pekrn, mobile } = props;
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.SECURITY_ANSWER,
            };

            let res: any = await props.verifyOTP(payload);
            updateSecurityQuestions();
        } catch (err: any) {
            alert(err.message);
        }
    };

    const updateSecurityQuestions = async () => {
        try {
            const { state, reqId } = props.location.state;
            const { pan, pekrn } = props;
            const payload = {
                pan,
                reqId,
                pekrn,
                mobile,
                data: state.map((question: any) => ({
                    ...question,
                    secretAnswer: EncodeBase64(question.secretAnswer),
                })),
            };
            await props.updateSecurityQuestionsForUser(payload);

            props.history.replace('update-security-questions-success');
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            const { pan = '', pekrn = '', mobile: existingMobile } = props;
            let payload = {
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.SECURITY_ANSWER,
            };

            let res = await props.sendPhoneOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back to profile"
                    onClick={() => props.history.push('/portal/profile')}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.push('/portal/profile');
                        }
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                </a>
                {updateSecurityQuestion.heading}
            </h2>
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            <span>{maskMobileNumber(mobile)}</span>
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <Button
                            disabled={otpInput.join('').length !== 6}
                            onClick={handleSubmit}
                            className="customBtn"
                        >
                            {dashboard.OtpScreen.buttonText}
                        </Button>
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    verifyOTP,
    sendPhoneOTP,
    updateSecurityQuestionsForUser,
})(UpdateSecurityQuestionsOtp);
